import React from 'react';

const useClickOutside = (
  ref: React.RefObject<HTMLElement>,
  isOpen: boolean,
  onClose: () => void,
  dropdownClass?: string
) => {
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      if (ref.current && !ref.current.contains(target)) {
        if (dropdownClass) {
          const dropdown = document.querySelector(`.${dropdownClass}`);
          if (!dropdown || !dropdown.contains(target)) {
            onClose();
          }
        } else {
          onClose();
        }
      }
    };

    if (isOpen) {
      setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside);
      }, 100);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, ref, onClose, dropdownClass]);
};

export default useClickOutside;
